@if (localSorting().errorMessage) {
<!--	Ideally be implemented in our linter when we get to that part of tech debt  -->
	<div class="error-banner">
		<p>{{ localSorting().errorMessage }}</p>
	</div>
} @else {
  <div class="table-container">
    @if (paginated()) {
      <div class="pagination-container">
        <lib-table-pagination
          [savePageLocalStorageKey]="savePageLocalStorageKey()"
          (paginationChange)="paginationChange($event)"
          [itemsPerPageOptions]="itemsPerPageOptions()"
          [pagination]="pagination()"
        />
      </div>
    }
    @if (!isLoading() && !tableRows.length) {
      <div class="no-data-container">
        <div class="no-data-message">
          <p>{{noDataMessage()}}</p>
        </div>
      </div>
    } @else {
      <div>
        <table class="table-responsive">
          <ng-content select="[table-header]"></ng-content>
          @if (isLoading()) {
            <tbody lib-skeleton-table-body [skeletonCells]="skeletonCells" [skeletonRows]="skeletonRows" class="table-body-container"></tbody>
          } @else {
            <ng-content select="[table-rows]"></ng-content>
          }
        </table>
      </div>
    }
  </div>
}
